import { OnlineSalesUnauthenticated } from 'gw-edge-client';
import type { CustomerStopDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto';
import { useRecoilValue } from 'recoil';
import { isLoggedOnSelector } from '../selectors/isLoggedOnSelector';
import { jobInfoAtom } from '../atoms/jobInfoAtom';

export const useGetAIDCustomerStop = (): {
    getAIDCustomerStop: (cprNumber: string, zipCode: string) => Promise<CustomerStopDTO>;
} => {
    const { jobNumber, sessionId } = useRecoilValue(jobInfoAtom);

    const isLoggedOn = useRecoilValue(isLoggedOnSelector);
    const getAIDCustomerStop = async (
        cprNumber: string,
        zipCode: string
    ): Promise<CustomerStopDTO> => {
        return await OnlineSalesUnauthenticated.getAIDCustomerStop(
            jobNumber,
            cprNumber,
            zipCode,
            sessionId,
            !isLoggedOn
        );
    };

    return { getAIDCustomerStop };
};
